module.exports = __webpack_public_path__ + "static/media/fast_game_lightning.41f15680.svg";